"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractPointerDataType = void 0;

var ethUtil = require("ethereumjs-util");

var pointer_1 = require("../../calldata/blocks/pointer");

var constants_1 = require("../../utils/constants");

var data_type_1 = require("../data_type");

var AbstractPointerDataType = /*#__PURE__*/function (_data_type_1$DataType) {
  _inherits(AbstractPointerDataType, _data_type_1$DataType);

  var _super = _createSuper(AbstractPointerDataType);

  function AbstractPointerDataType(dataItem, factory, destination, parent) {
    var _this;

    _classCallCheck(this, AbstractPointerDataType);

    _this = _super.call(this, dataItem, factory);
    _this._destination = destination;
    _this._parent = parent;
    return _this;
  }

  _createClass(AbstractPointerDataType, [{
    key: "generateCalldataBlock",
    value: function generateCalldataBlock(value, parentBlock) {
      if (parentBlock === undefined) {
        throw new Error("DependentDataType requires a parent block to generate its block");
      }

      var destinationBlock = this._destination.generateCalldataBlock(value, parentBlock);

      var name = this.getDataItem().name;
      var signature = this.getSignature();
      var parentName = parentBlock.getName();
      var block = new pointer_1.PointerCalldataBlock(name, signature, parentName, destinationBlock, parentBlock);
      return block;
    }
  }, {
    key: "generateValue",
    value: function generateValue(calldata, rules) {
      var destinationOffsetBuf = calldata.popWord();
      var destinationOffsetHex = ethUtil.bufferToHex(destinationOffsetBuf);
      var destinationOffsetRelative = parseInt(destinationOffsetHex, constants_1.constants.HEX_BASE);
      var destinationOffsetAbsolute = calldata.toAbsoluteOffset(destinationOffsetRelative);
      var currentOffset = calldata.getOffset();
      calldata.setOffset(destinationOffsetAbsolute);

      var value = this._destination.generateValue(calldata, rules);

      calldata.setOffset(currentOffset);
      return value;
    } // Disable prefer-function-over-method for inherited abstract method.

    /* tslint:disable prefer-function-over-method */

  }, {
    key: "isStatic",
    value: function isStatic() {
      return true;
    }
  }]);

  return AbstractPointerDataType;
}(data_type_1.DataType);

exports.AbstractPointerDataType = AbstractPointerDataType;